import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '@/context/auth-context'

export default function UserProfile() {
  const { t } = useTranslation()
  const { user, logout } = useContext(AuthContext)

  // console.log(`User: `, user);

  return (
     <div
      className="flex items-center justify-between px-6 py-3 text-sm/6 font-semibold text-white md:hover:bg-indigo-950/25"
    >
      <div className="flex items-center gap-x-4">
        <span aria-hidden="true">{user?.name || t('sidebar.profile.unknownUser')}</span>
      </div>
      <a href="#" onClick={() => logout()}>{t('sidebar.profile.logout')}</a>
    </div>
  )
}
